import script from "./FilePondUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./FilePondUploader.vue?vue&type=script&setup=true&lang=js"

import "./FilePondUploader.vue?vue&type=style&index=0&id=2118b8ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2118b8ed"]])

export default __exports__